import { createAction } from 'redux-actions';

export const OPEN_CHAT_WINDOW = 'glints/liveChat/OPEN_ZENDESK_CHAT_WINDOW';

/*
  This is a dummy action to trigger live chat API's via GTM, since every redux action is registered there.
  Thus, it doesn't require a corresponding reducer as no state change is induced.
*/
export const openChatWindow = createAction(OPEN_CHAT_WINDOW);
